<template>
  <article>
    <v-tooltip v-if="showPaymentButton" top max-width="300" :disabled="!paymentButtonRestriction">
      <template v-slot:activator="{ on, attrs }">
        <span class="d-block" v-bind="attrs" v-on="on">
          <v-btn
            class="font-weight-medium payment-button"
            width="100%"
            :color="buttonColor"
            :dark="!paymentButtonRestriction"
            depressed
            large
            :disabled="!!paymentButtonRestriction"
            @click="handleClick"
          >
            <v-img
              v-if="!isOrderPaid"
              max-height="31"
              max-width="31"
              class="wallet-icon"
              src="img/wallet.svg"
            ></v-img>
            {{ buttonText }}
          </v-btn>
        </span>
      </template>
      {{ paymentButtonRestriction }}
    </v-tooltip>
    <v-alert v-else-if="isOrderPaid" type="success">
      Заказ оплачен
    </v-alert>
    <payment-dialog @paid="refreshCurrentOrder" />
    <cancel-payment-dialog v-model="showCancelDialog" @canceled="refreshCurrentOrder" />
  </article>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import PaymentDialog from '../payment/PaymentDialog.vue'
  import DeliveryType from '@/models/enums/DeliveryType'
  import CancelPaymentDialog from '../payment/CancelPaymentDialog.vue'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'
  import OrderStatus from '@/models/enums/OrderStatus'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import { refundRestrictionReason } from '@/util/order-cancel'

  export default {
    name: 'Payment',
    components: { PaymentDialog, CancelPaymentDialog },
    props: {
      payment: Object,
    },
    data () {
      return {
        showCancelDialog: false,
      }
    },
    computed: {
      ...mapState({
        currentEditOrder: state => state.orders.currentEditOrder,
        orderStatus: state => state.baskets.orderStatus,
      }),
      ...mapGetters({
        isOrderPaid: 'orders/isOrderPaid',
        orderCancelFlags: 'auth/orderCancelFlags',
      }),
      canBePayedInCRM () {
        const order = this.currentEditOrder

        return this.userCan(CRMPermission.MakeOrderPayment) &&
          !order?.basket?.isAggregator &&
          order?.basket?.paymentType !== PaymentType.Online &&
          (order?.basket?.deliveryType === DeliveryType.Self || order?.paymentMode === PaymentMode.PayNow)
      },
      // Оплаченный: «Отменить платёж», кроме завершённого. Неоплаченный: «Оплатить», кроме отменённого -
      // бэк такую оплату отклонит. У отменённого оплаченного возврат остаётся: единственный способ разобрать платёж
      showPaymentButton () {
        if (!this.canBePayedInCRM) return false

        return this.isOrderPaid
          ? this.orderStatus !== OrderStatus.Completed
          : this.orderStatus !== OrderStatus.Canceled
      },
      // «Отменить платеж» - возврат без отмены заказа: по заказу прошлой смены - только с правом или флагом прошлых дней.
      // «Оплатить» правилом не ограничена
      paymentButtonRestriction () {
        return this.isOrderPaid ? refundRestrictionReason(this.currentEditOrder, this.orderCancelFlags) : null
      },
      buttonText () {
        return this.isOrderPaid ? 'Отменить платеж' : 'Оплатить'
      },
      buttonColor () {
        return this.isOrderPaid ? '#434343' : '#FF5252'
      },
    },
    methods: {
      handleClick () {
        this.isOrderPaid
          ? this.showCancelDialog = true
          : this.$store.commit('orders/setShowPaymentDialog', true)
      },
      refreshCurrentOrder () {
        this.$store.dispatch('orders/refreshCurrentOrder', this.$route.query.id)
      },
    },
  }
</script>

<style lang="less" scoped>
  .payment-button {
    position: relative;
    border-radius: 10px;
    padding: 0 20px !important;
  }
  .wallet-icon {
    position: absolute;
    left: 0;
  }
</style>
